export default function ClarksvilleLocalAreaSection() {
  return (
    <section id="local-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Coverage</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Clarksville & Surrounding Areas
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            We cover all of Montgomery County and extend into surrounding Kentucky communities near Fort Campbell.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Fort%20Campbell%20military%20base%20entrance%20sign%20with%20American%20flags%20and%20green%20landscaping%2C%20sunny%20day%2C%20respectful%20military%20installation%20photography%2C%20warm%20natural%20light%20with%20clear%20blue%20sky%20background&width=800&height=400&seq=clarksville-local1&orientation=landscape"
                alt="Fort Campbell Military Base"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-2">Fort Campbell Military Base</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Home to the 101st Airborne Division and 160th Special Operations Aviation Regiment. We specialize in deployment-ready passport processing for soldiers and their families stationed at Fort Campbell.
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Austin%20Peay%20State%20University%20campus%20with%20historic%20buildings%20and%20green%20lawn%20areas%2C%20college%20students%20walking%20between%20classes%2C%20bright%20sunny%20day%20in%20Clarksville%20Tennessee%2C%20editorial%20photography&width=800&height=400&seq=clarksville-local2&orientation=landscape"
                alt="Austin Peay State University"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-2">Austin Peay State University</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Serving APSU students with study abroad programs, international research, and student teaching placements abroad. We offer student-friendly rates and semester deadline guarantees.
              </p>
            </div>
          </div>
        </div>

        {/* Coverage areas */}
        <div className="bg-white rounded-xl p-8">
          <h3 className="font-serif text-xl font-bold text-[#1A365D] mb-6 text-center">Areas We Serve</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {[
              "Clarksville",
              "Fort Campbell",
              "Oak Grove, KY",
              "Hopkinsville, KY",
              "Pleasant View",
              "Sango",
              "Cunningham",
              "Southside",
              "Adams",
              "Woodlawn",
              "Cedar Hill",
              "Port Royal",
            ].map((area, i) => (
              <div key={i} className="flex items-center gap-2 bg-[#F7F8FA] px-4 py-3 rounded-lg">
                <i className="ri-map-pin-2-line text-[#F6C344] text-sm"></i>
                <span className="text-[#1A365D] text-sm font-medium">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}